import gameday from '@gameday/common/assets/images/game_day.svg'
import styled from 'styled-components'

const Wrapper = styled.footer`
  display: flex;
  width: 100%;
  height: 74px;
  padding: 0 16px;
  align-items: center;
  justify-content: space-between;
  background: var(--white);
  box-shadow: 0px -4px 10px rgba(0, 0, 0, 0.05);
`

const Logo = styled.img`
  max-height: 40px;
  @media only screen and (max-width: 540px) {
    &.gameday {
      display: none;
    }
  }
`

const Copyright = styled.p`
  font-size: 12px;
  color: var(--dark-text);
  @media only screen and (max-width: 540px) {
    font-size: 8px;
  }
`

const Footer = ({ logo, title }) => (
  <Wrapper>
    {logo && <Logo src={logo} alt={title && title} />}
    <Copyright>Copyright GameDay. All rights reserved.</Copyright>
    <Logo src={gameday} alt="GameDay" className="gameday" />
  </Wrapper>
)

Footer.defaultProps = {
  logo: gameday,
}

export default Footer
